import { useContext, useEffect, useMemo } from 'react';
import { clearSpoofSession } from 'clients/spoofSession';
import useAuthenticatedUserClient from 'clients/useAuthenticatedUserClient';
import { AuthContext } from 'contexts/AuthContext';
import { queryClient } from 'contexts/QueryClient';
import { ClientId, Token, getUserToken, useToken } from 'hooks/useToken';
import { resetUser } from 'utils/posthog';

export function AuthProvider({ children }: { children: JSX.Element }) {
  const { addTokenForClientId, removeTokenForClientId } = useToken();
  const userClients = useAuthenticatedUserClient();
  useEffect(() => {
    const username = localStorage.getItem('user')?.toLowerCase();
    if (username) {
      const token = getUserToken(username);
      if (token) {
        addTokenForClientId('core', token, `${username}-user`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem('user')?.toLowerCase();
    if (userId) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).usetifulTags = { userId: userId };
    }
  }, []);

  const login = (clientId: ClientId, token: Token, userId: string) => {
    addTokenForClientId(clientId, token, `${userId.toLowerCase()}-user`);
  };

  const logout = () => {
    resetUser();
    queryClient.cancelQueries();
    queryClient.clear();
    clearSpoofSession();
    removeTokenForClientId('core', 'user');
  };

  const value = useMemo(
    () => ({
      login,
      logout,
      clients: userClients,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userClients]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export const useAuth = () => useContext(AuthContext);
